import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from '@utils/validation/isEmpty';
import { useAgentId } from '@hooks/useAgentId';
import vdnSettingsActions from '@store/actions/vdnSettings';

export const useVdnVersionGet = () => {
  const dispatch = useDispatch();
  const { agentId } = useAgentId();
  const versions = useSelector(state => state.vdnSettings.versions);

  useEffect(() => {
    if (!isEmpty(agentId)) {
      dispatch(vdnSettingsActions.getVdnVersions(agentId));
    }
  }, [agentId]);

  return { versions };
};
